<template>
  <div class="max-w-7xl">
    <FilterSection
      :showInputSearchProd="true"
      :placeholder="'Buscar pelo nome do estudante...'"
      title="Gerenciamento de Inscrições e Matrículas"
      :showYear="true"
      :showDateInterval="false"
      :showAddButton="false"
      :searchQuery="searchQuery"
      :setSearchQuery="(val) => (searchQuery = val)"
      :entryYear="entryYear"
      :setEntryYear="(val) => (entryYear = val)"
      :typeFilterInscription="typeFilterInscription"
      :setTypeFilterInscription="(val) => (typeFilterInscription = val)"
    />
    <DataTable :columns="columns" :data="inscriptionsData">
      <template #actions="{ row }">
        <div class="flex gap-2">
          <button
            :class="
              row.inscription_paid === 1
                ? 'text-gray-400 cursor-not-allowed'
                : 'text-blue-500'
            "
            @click="handleEdit(row)"
            :disabled="row.inscriptionType === 1"
          >
            Editar
          </button>
          <button class="text-orange-500" @click="handleDetails(row)">
            Detalhes
          </button>
        </div>
      </template>
    </DataTable>

    <TableNavigation
      :currentPage="current_page"
      :perPage="per_page"
      :totalItems="total"
      @page-change="
        (page) => {
          current_page = page;
          getAllInscriptions(page);
        }
      "
    />

    <!-- Modal de edicao do dados do estudante  -->
    <BaseModal
      v-model:modalValue="IsPersonalData"
      title="Actualizar dados do candidato"
      @update:modalValue="(value) => (IsPersonalData = value)"
    >
      <div class="max-w-6xl">
        <div class="row">
          <div class="col-lg-3 mb-2 bg-card">
            <img
              src="../../../public/assets/images/userProfile.svg"
              class="rounded-cirlce"
              width="133"
              height="133"
              alt=""
            />
          </div>

          <div class="row mt-4 col-lg-12">
            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="form-group">
                <label for=""
                  >Nome Completo<span class="text-danger">:*</span></label
                >
                <input
                  @input="onUserTypefullName"
                  v-model="studentForm.fullName"
                  type="text"
                  class="form-control"
                />
              </div>
              <p v-if="fullname_message_error" style="color: red">
                {{ fullname_message_error }}
              </p>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="form-group">
                <label for=""
                  >Nome do Pai<span class="text-danger">:*</span></label
                >
                <input
                  @input="onUserTypeFatherName"
                  v-model="studentForm.fathers_filliation"
                  type="text"
                  class="form-control"
                />
              </div>
              <p v-if="father_name_message_error" style="color: red">
                {{ father_name_message_error }}
              </p>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="form-group">
                <label for=""
                  >Nome da Mãe<span class="text-danger">:*</span></label
                >
                <input
                  @input="onUserTypeMotherName"
                  v-model="studentForm.mothers_filliation"
                  type="text"
                  class="form-control"
                />
              </div>
              <p v-if="mother_name_message_error" style="color: red">
                {{ mother_name_message_error }}
              </p>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <div class="form-group">
                <label for="">Genero<span class="text-danger">:*</span></label>
                <select
                  @input="onUserTypeGender"
                  class="form-control"
                  v-model="studentForm.gender"
                >
                  <option value="">Genero</option>
                  <option value="Masculino">Masculino</option>
                  <option value="Feminino">Feminino</option>
                </select>
              </div>
              <p v-if="gender_message_error" style="color: red">
                {{ gender_message_error }}
              </p>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <div class="form-group">
                <label for=""
                  >Data de Nasci.<span class="text-danger">:*</span></label
                >
                <input
                  v-model="studentForm.birthDate"
                  type="date"
                  class="form-control"
                  @input="onUserTypeBithDate"
                />
              </div>
              <p v-if="birthDate_message_error" style="color: red">
                {{ birthDate_message_error }}
              </p>
            </div>

            <div class="col-lg-4">
              <div class="form-group">
                <label for=""
                  >Contacto<span class="text-danger">:*</span></label
                >
                <input
                  v-model="studentForm.contacts.contact"
                  type="text"
                  @keypress="numberOnly"
                  pattern="/^[0-9]+$/"
                  maxlength="9"
                  class="form-control"
                  @input="validatePhoneNumber"
                />
              </div>
              <p v-if="phoneNumberError" style="color: red">
                {{ phoneNumberError }}
              </p>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="form-group">
                <label for="">Contacto Alternativo:</label>

                <input
                  type="text"
                  class="form-control"
                  @keypress="numberOnly"
                  pattern="/^[0-9]+$/"
                  maxlength="9"
                  v-model="studentForm.contacts.alternative_contact"
                  @input="validatePhoneNumberAlternative"
                />
              </div>
              <p v-if="phoneNumberErrorAlternative" style="color: red">
                {{ phoneNumberErrorAlternative }}
              </p>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="form-group">
                <label for="">Email<span class="text-danger">:*</span></label>
                <input
                  type="email"
                  class="form-control"
                  v-model="studentForm.email"
                  @input="validateEmail"
                />
              </div>
              <p v-if="emailError" style="color: red">{{ emailError }}</p>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="form-group">
                <label class="form-label"
                  >Tem alugma deficiencia?<span class="text-danger"
                    >:*</span
                  ></label
                >
                <select
                  class="form-control"
                  v-model="studentForm.is_deficient"
                  @change="is_deficientChange($event)"
                  disabled
                >
                  <option value="">Selecione</option>
                  <option value="0">Não</option>
                  <option value="1">Sim</option>
                </select>
              </div>
              <p v-if="isDeficient_message_error" style="color: red">
                {{ isDeficient_message_error }}
              </p>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="form-group">
                <label class="form-label"
                  >Selecione o tipo de deficiencia</label
                >
                <select
                  class="form-control"
                  v-model="studentForm.deficient_type"
                  :disabled="deficientTypeDisabled"
                  disabled
                >
                  <option value="" selected>Selecione o tipo</option>
                  <option value="Deficiencia Visual">Deficiencia Visual</option>
                  <option value="Cegueira">Cegueira</option>
                  <option value="Paraplegia">Paraplegia</option>
                  <option value="Paraparesia">Paraparesia</option>
                  <option value="Monoplegia">Monoplegia</option>
                  <option value="Baixa Visao">Baixa visao</option>
                  <option value="HipoMiopia">HipoMiopia</option>
                  <option value="HiperMiopia">HiperMiopia</option>
                  <option value="Surdez Condutiva">Surdez Condutiva</option>
                  <option value="Surdez Sensorioneural">
                    Surdez Sensorioneural
                  </option>
                  <option value="Surdez Mista">Surdez Mista</option>
                  <option value="Surdez Central">Surdez Central</option>
                </select>
              </div>
              <p v-if="deficientType_message_error" style="color: red">
                {{ deficientType_message_error }}
              </p>
            </div>

            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="form-group">
                <label for=""
                  >Curso selecionado<span class="text-danger">:*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="studentForm.curso"
                  disabled
                />
              </div>
            </div>

            <div class="mb-2 col-12 col-sm col-lg-4">
              <div class="form-group">
                <label for="" class="">Actualizar o curso</label>
                <v-select
                  v-model="studentForm.curseToUpdateOld"
                  :options="course"
                  :get-option-label="(option) => `${option.name}`"
                  :reduce="(option) => option.id"
                  :filterable="true"
                  :filter="courseFilter"
                  class="style-chooser"
                >
                  <template #option="{ name, id }">
                    {{ name }}
                    <br />
                    <!-- <cite>Código: {{ customer_id }}</cite> -->
                  </template>
                </v-select>
              </div>
            </div>
          </div>

          <div class="row col-lg-12 mt-4">
            <Tabs :animated="false" class="col-lg-12">
              <TabPane label="Habilitações">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="form-group">
                      <label for=""
                        >última Escola<span class="text-danger">:*</span></label
                      >
                      <input
                        @input="onUserTypeLastSchoolFrequency"
                        type="text"
                        v-model="studentForm.last_school_frequency"
                        class="form-control"
                        disabled
                      />
                    </div>
                    <p v-if="last_school_message_error" style="color: red">
                      {{ last_school_message_error }}
                    </p>
                  </div>

                  <div class="col-lg-2">
                    <div class="form-group">
                      <label for="">Área de Formação:*</label>
                      <input
                        @input="onUserTypeTrainingArea"
                        v-model="studentForm.trainingArea"
                        type="text"
                        class="form-control"
                        disabled
                      />
                    </div>
                    <p v-if="trainingArea_message_error" style="color: red">
                      {{ trainingArea_message_error }}
                    </p>
                  </div>

                  <div class="col-lg-2">
                    <div class="form-group">
                      <label for=""
                        >Ano de Conclusão<span class="text-danger"
                          >:*</span
                        ></label
                      >
                      <select
                        @change="onUserTypeLastSchoolYear"
                        class="form-control"
                        v-model="studentForm.last_school_frequency_year"
                        disabled
                      >
                        <option :value="y" v-for="y in years" :key="y">
                          {{ y }}
                        </option>
                      </select>
                    </div>
                    <p v-if="last_school_year_message_error" style="color: red">
                      {{ last_school_year_message_error }}
                    </p>
                  </div>

                  <div class="col-lg-2">
                    <div class="form-group">
                      <label for=""
                        >Tem Certificado<span class="text-danger"
                          >:*</span
                        ></label
                      >
                      <select
                        @change="onUserTypeHasCertificate"
                        class="form-control"
                        v-model="studentForm.hasCertificate"
                        disabled
                      >
                        <option value="">Selecione</option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                      </select>
                    </div>
                    <p v-if="hasCertificate_message_error" style="color: red">
                      {{ hasCertificate_message_error }}
                    </p>
                  </div>
                </div>
              </TabPane>
              <TabPane label="Endereço">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label for=""
                        >País<span class="text-danger">:*</span></label
                      >
                      <select
                        @change="changeContry"
                        v-model="studentForm.nactionality"
                        class="form-control"
                        disabled
                      >
                        <option
                          :value="c.name"
                          v-for="c in countries.location"
                          :key="c"
                        >
                          {{ c.name }}
                        </option>
                      </select>
                    </div>
                    <p v-if="country_message_error" style="color: red">
                      {{ country_message_error }}
                    </p>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label for=""
                        >Provincia<span class="text-danger">:*</span></label
                      >
                      <select
                        disabled
                        class="form-control"
                        v-model="studentForm.province_id"
                        @change="ChangeProvince"
                      >
                        <option value="Class">Selecione o Provincia</option>
                        <option
                          :value="p.id"
                          v-for="(p, index) in provinces"
                          :key="index"
                        >
                          {{ p.name }}
                        </option>
                      </select>
                    </div>
                    <p v-if="province_message_error" style="color: red">
                      {{ province_message_error }}
                    </p>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label for=""
                        >Distrito<span class="text-danger">:*</span></label
                      >
                      <select
                        @change="OnUserChangeDistrict"
                        class="form-control"
                        v-model="studentForm.district_id"
                        disabled
                      >
                        <option value="Class">Selecione o Distrito</option>
                        <option
                          :value="d.id"
                          v-for="(d, index) in districtData"
                          :key="index"
                        >
                          {{ d.name }}
                        </option>
                      </select>
                    </div>
                    <p v-if="district_message_error" style="color: red">
                      {{ district_message_error }}
                    </p>
                  </div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label for=""
                        >Bairro/AVENIDA<span class="text-danger"
                          >:*</span
                        ></label
                      >
                      <input
                        disabled
                        @input="onUserTypeAddressLocation"
                        v-model="studentForm.address_location"
                        type="text"
                        class="form-control"
                      />
                    </div>
                    <p v-if="address_message_error" style="color: red">
                      {{ address_message_error }}
                    </p>
                  </div>
                  <div class="col-lg-1">
                    <div class="form-group">
                      <label for="">Quart.:</label>
                      <input
                        v-model="studentForm.block"
                        type="text"
                        class="form-control"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-lg-1">
                    <div class="form-group">
                      <label for="">Nc:</label>
                      <input
                        v-model="studentForm.house_number"
                        type="text"
                        class="form-control"
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </TabPane>
              <TabPane label="Documentos de Identificação">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="form-group">
                      <label for=""
                        >Tipo Doc.Ident.<span class="text-danger"
                          >:*</span
                        ></label
                      >
                      <select
                        @change="onUserTypeDocument"
                        class="form-control"
                        v-model="studentForm.doc_type"
                        disabled
                      >
                        <option value="">Selecione o tipo documento</option>
                        <option value="Bilhete de Identidade">
                          Bilhete de Identidade
                        </option>
                      </select>
                    </div>
                    <p v-if="doc_message_error" style="color: red">
                      {{ doc_message_error }}
                    </p>
                  </div>

                  <div class="col-lg-3">
                    <div class="form-group">
                      <label for=""
                        >N&ordm; do Documento<span class="text-danger"
                          >:*</span
                        ></label
                      >
                      <input
                        v-model="studentForm.doc_number"
                        type="text"
                        class="form-control"
                        maxlength="13"
                        @input="validateIdentificationNumber"
                        disabled
                      />
                    </div>
                    <p v-if="doc_number_message_error" style="color: red">
                      {{ doc_number_message_error }}
                    </p>
                  </div>
                </div>
              </TabPane>
            </Tabs>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="success"
            @click="UpdateStudentData"
            data-dismiss="modal"
            :loading="loading"
          >
            Actualizar
          </button>
          <Button type="error" @click="ClosePersonalData"> Fechar </Button>
        </div>
      </div>
    </BaseModal>

    <Loading :loading-data="loading" />
    <!-- <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Nome</th>
          <th scope="col">Curso</th>
          <th scope="col">Nível Académico</th>
          <th scope="col">Regime</th>
          <th scope="col">Ano Académico</th>
          <th scope="col">Semestre</th>
          <th scope="col">Tipo</th>
          <th scope="col">Ano de Entrada</th>
          <th scope="col">Estudante Activo</th>
          <th scope="col">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(i, index) in inscriptionsData" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ i.fullName }}</td>
          <td>{{ i.course }}</td>
          <td>{{ i.level }}</td>
          <td>{{ i.scholar_shift }}</td>
          <td>{{ i.academic_year }}&#176;</td>
          <td>{{ i.semester }}</td>
          <td>{{ i.inscriptionType }}</td>
          <td>{{ i.ano_entrada }}</td>
          <td v-if="i.isActive == 0">
            <span class="badge badge-danger">Inactivo</span>
          </td>
          <td v-else><span class="badge badge-success">Activo</span></td>
          <td>
            <div class="action-column" v-if="i.inscriptionType == 'Inscrição'">
              <a
                @click="confrimPaymentInscriprion(index, i.id)"
                class="btn btn-sm btn-success text-white"
                ><i class="fa fa-coins text-white"></i> Confirmar o pagamento?
              </a>
            </div>
            <div v-else class="action-column">
              <a
                title="Aprovar Candidatura"
                @click="approveCandidate(index, i.id, i.person_id, i.course_id)"
                class="btn btn-sm mr-1 btn-success btn-xs"
                style="font-size: 13px"
                ><i class="fa fa-check text-white"></i>
              </a>
              <a
                title="reprovar Candidatura"
                @click="
                  repproveCandidate(index, i.id, i.person_id, i.course_id)
                "
                class="btn btn-sm mr-1 btn-danger btn-xs"
                style="font-size: 13px"
                ><i class="fa fa-times text-white"></i>
              </a>
            </div>
          </td>
        </tr>
        <tr v-if="inscriptionsData.length == 0">
          <td colspan="12" class="text-center" style="font-style: italic">
            <span>Ainda não tem registro</span>
          </td>
        </tr>
      </tbody>
    </table>
    <Page
      :total="total"
      :model-value="current_page"
      :page-size="parseInt(per_page)"
      @on-change="getAllInscriptions"
      v-if="total > 0"
      class="float-right"
    /> -->
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import InscriptionStoreModule from "../inscriptions/InscriptionStoreModule.js";
import Loading from "../../components/Loading.vue";
import Swal from "sweetalert2";
import PaymentStoreModule from "../payments/PaymentStoreModule.js";
import { toast } from "vue3-toastify";
import { useRoute, useRouter } from "vue-router";
import toastr from "toastr";
import DataTable from "@/components/DataTable.vue";
import axiosInstance from "@/utils/axiosInstance.js";
import { API_PATHS } from "@/utils/apiPaths.js";
import TableNavigation from "@/components/TableNavigation.vue";
import BaseModal from "@/components/BaseModal.vue";
import { useLocationStore } from "@/store/useLocation.js";
import FilterSection from "@/components/Dashboard/FilterSection.vue";
import { watch } from "vue";
import router from "@/router/index.js";

const entryYear = ref("");
const typeFilterInscription = ref("");
const searchQuery = ref("");

const IsPersonalData = ref(false);
const route = useRoute();
const districtData = ref([]);
const provinces = ref([]);
const countries = useLocationStore();
const inscriptionsData = ref([]);
const loading = ref(false);
const total = ref(null);
const inscriptionType = ref("todas");
const current_page = ref(null);
const per_page = ref(null);
const years = ref([]);
const filters = ref({
  semester_id: "",
  year: new Date().getFullYear(),
  course_id: "",
  status: "confirmed",
});
const columns = [
  { key: "fullName", title: "Nome Completo" },
  { key: "course", title: "Curso" },
  { key: "level", title: "Graduação" },
  { key: "scholar_shift", title: "Turno" },
  { key: "academic_year", title: "Ano Académico" },
  { key: "semester", title: "Semestre" },
  { key: "inscriptionType", title: "Tipo" },
  { key: "ano_entrada", title: "Ano de Entrada" },
  { key: "status", title: "Estado" },
  {
    title: "Ações",
    key: "actions",
    render: (row) => {
      // retorna um string ou JSX-like usando h()
      return `
        <div class="flex gap-2">
          <button class="text-blue-500" @click="edit(${row.id})">Editar</button>
          <button class="text-red-500" @click="delete(${row.id})">Deletar</button>
        </div>
      `;
    },
  },
];
const studentForm = ref({
  id: "",
  person_id: "",
  entry_year: "",
  fullName: "",
  fathers_filliation: "",
  mothers_filliation: "",
  gender: "",
  birthDate: "",
  contacts: {
    contact: "",
    alternative_contact: "",
  },
  academic_year: "",
  email: "",
  last_school_frequency: "",
  last_school_frequency_year: "",
  nactionality: "Moçambique",
  address_location: "",
  district_id: "",
  district: "",
  province_id: "",
  province: "",
  doc_type: "",
  doc_number: "",
  hasCertificate: 0,
  is_deficient: "",
  deficient_type: "",
  trainingArea: "",
  block: "", //Quarteirao do estudante
  house_number: "", //numero da casa
  emissionLocation: "",
  dateEndDocument: "",
  curso: "",
  curseToUpdateOld: "",
});
const enableProviceAndDistrict = ref(false);
const deficientTypeDisabled = ref(true);
const course = ref([]);

// Fecha modal Dados pessoais
function ClosePersonalData() {
  IsPersonalData.value = false;

  clearInputs();
}

const handleEdit = (row) => {
  try {
    IsPersonalData.value = true;

    // Busca o estudante selecionado para visualizacao de dados
    // let findStudentToUpdate = inscriptionsData.value.find(
    //   (item) => item.person_id == row.person_id
    // );

    // if (studentForm.value.nactionality !== "Moçambique") {
    //   studentForm.value.district = null;
    //   studentForm.value.province = null;

    // } else {
    //   let findDistrict = districtData.value.find(
    //     (item) => item.id === findStudentToUpdate.district_id
    //   );
    //   let findProvince = provinces.value.find(
    //     (item) => item.id === findStudentToUpdate.province_id
    //   );
    //   console.log(findDistrict);

    //   inscriptionsData.value[index].province = findProvince?.name;
    //   // studentData.value[index].district = findDistrict.name;
    // }

    enableProviceAndDistrict.value =
      row.nactionality == "Moçambique" ? false : true;

    if (row.is_deficient != "" && row.is_deficient == 1) {
      deficientTypeDisabled.value = false;
    } else {
      deficientTypeDisabled.value = true;
    }
    studentForm.value.id = row.id;
    studentForm.value.curso = row.course;
    studentForm.value.person_id = row.person_id;
    studentForm.value.fullName = row.fullName;
    studentForm.value.mothers_filliation = row.mothers_filliation;
    studentForm.value.fathers_filliation = row.fathers_filliation;
    studentForm.value.gender = row.gender;
    studentForm.value.birthDate = row.birthDate;
    studentForm.value.contacts.contact = row.contact;
    studentForm.value.contacts.alternative_contact = row.alternative_contact;
    studentForm.value.email = row.email;
    studentForm.value.is_deficient = row.is_deficient;
    studentForm.value.deficient_type = row.deficient_type;
    studentForm.value.last_school_frequency = row.last_school_frequency;
    studentForm.value.last_school_frequency_year =
      row.last_school_frequency_year;
    studentForm.value.nactionality = row.nactionality;
    studentForm.value.province_id = row.province_id;
    studentForm.value.district_id = row.district_id;
    studentForm.value.address_location = row.address_location;
    studentForm.value.doc_type = row.doc_type;
    studentForm.value.doc_number = row.doc_number;
    studentForm.value.trainingArea = row.trainingArea;
    studentForm.value.block = row.block;
    studentForm.value.house_number = row.house_number;
    studentForm.value.hasCertificate = row.hasCertificate;
  } catch (error) {
    console.log(error);
  }
};

// Responsavel por fazer a submissao dos dados para actualizacao
async function UpdateStudentData() {
  try {
    loading.value = true;

    if (
      studentForm.value.fullName == "" ||
      studentForm.value.fullName == null
    ) {
      loading.value = false;
      toast.info("O campo nome completo não pode estar vazio!", {
        autoClose: 1000,
      });
      return;
    }

    if (
      studentForm.value.fathers_filliation == "" ||
      studentForm.value.fathers_filliation == null
    ) {
      loading.value = false;
      toast.info("O campo nome do pai não pode estar vazio!", {
        autoClose: 1000,
      });
      return;
    }

    if (studentForm.value.mothers_filliation == "") {
      loading.value = false;
      toast.info("O campo nome da mae não pode estar vazio!", {
        autoClose: 1000,
      });
      return;
    }

    if (studentForm.value.gender == "") {
      loading.value = false;
      toast.info("O campo genero não pode estar vazio!", {
        autoClose: 1000,
      });
      return;
    }

    if (studentForm.value.birthDate == "") {
      loading.value = false;

      toast.info("O campo data de Nascimento não pode estar vazio!", {
        autoClose: 1000,
      });
      return;
    }

    if (studentForm.value.contacts.contact == "") {
      loading.value = false;
      toast.info("O campo contacto não pode estar vazio!", {
        autoClose: 1000,
      });
      return;
    }

    if (studentForm.value.email == "") {
      loading.value = false;
      toast.info("O campo email não pode estar vazio!", {
        autoClose: 1000,
      });
      return;
    }
    let currentYear = new Date().getFullYear();
    let year = new Date(studentForm.value.birthDate).getFullYear();

    if (studentForm.value.birthDate !== "") {
      loading.value = false;

      if (currentYear - year < 18) {
        toast.info("Menor de idade", { autoClose: 1000 });
        return;
      }
    }

    const resp = await axiosInstance.post(
      API_PATHS.STUDENT.updateCandidate(studentForm.value.person_id),
      studentForm.value
    );

    if (resp.data.status == true) {
      toastr.success(resp.data.msg);
      IsPersonalData.value = false;
      clearInputs();
    }
    console.log(resp);
  } catch (error) {
    if (typeof error.response != "undefined") {
      Object.keys(error.response.data.errors).forEach((key) => {
        toastr.info(key, error.response.data.errors[key]);
      });
    }
  } finally {
    loading.value = false;
  }
}

async function FilterCourse() {
  try {
    loading.value = true;
    const resp = await axiosInstance.get(API_PATHS.COURSES.AllCourses);
    course.value = resp.data;
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}
const handleDetails = (row) => {
  router.push(`/dashboard/candidate-information/${row.id}`);
};
async function getAllInscriptions(page = 1) {
  try {
    loading.value = true;
    const params = new URLSearchParams();

    if (page) {
      params.append("page", page);
    }
    if (filters.value.year) {
      params.append("year", filters.value.year);
    }

    if (searchQuery.value) {
      params.append("search", searchQuery.value);
    }

    if (entryYear.value) {
      params.append("entryYear", entryYear.value);
    }

    if (typeFilterInscription.value) {
      params.append("typefilter", typeFilterInscription.value);
    }

    if (inscriptionType.value) {
      params.append("tipo_inscricao", inscriptionType.value);
    }
    const resp = await axiosInstance.get(
      API_PATHS.INSCRIPTION.getAllInscription(params)
    );

    console.log(resp.data);

    inscriptionsData.value = resp.data.data;
    total.value = resp.data.meta.total;
    per_page.value = resp.data.meta.per_page;
    current_page.value = resp.data.meta.current_page;
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

async function handleDownloadpdf() {
  try {
    loading.value = true;

    const resp = await InscriptionStoreModule.actions.exportDataTopdf(
      filters.value.year
    );
    console.log(resp);
    window.open(
      resp.data.url,
      "Estatica das candidaturas",
      "height=1024,width=600"
    );
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}
async function approved(index, inscription_id, person_id, course_id) {
  try {
    loading.value = true;
    const data = {
      inscription_id: inscription_id,
      inscriptionType: "Inscrição",
      course_id: course_id,
    };

    inscriptionsData.value.splice(index, 1);

    const resp = await InscriptionStoreModule.actions.aproveInscription(
      data,
      person_id
    );

    if (resp.data.path) {
      toastr.success("Candidatura Aprovada com Sucesso.");
    } else {
      toastr.info(resp.data.message);
    }

    console.log(resp.data);

    // downloadPDF(resp.data.path);
  } catch (error) {
    console.log(error);
    if (error.response != "undefined") {
      Object.keys(error.response.data.errors).forEach((key) => {
        toastr.info(key, error.response.data.errors[key]);
      });
    }
  } finally {
    loading.value = false;
  }
}
async function approveCandidate(index, inscription_id, person_id, course_id) {
  Swal.fire({
    title: "Tem certeza que deseja aprovar esta candidatura?",
    text: "Não terá como reverter esta operação!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Sim, Eliminar!",
    cancelButtonText: "Cancel!",
  }).then((result) => {
    if (result.isConfirmed) {
      approved(index, inscription_id, person_id, course_id);
    }
  });
}

// Implentar a reprovacao da candidatura
async function repproveCandidate(index, inscription_id, person_id, course_id) {
  try {
    loading.value = true;
    const data = {
      inscription_id: inscription_id,
      inscriptionType: "Inscricao",
      course_id: course_id,
    };
    const resp = await InscriptionStoreModule.actions.aproveInscription(
      data,
      person_id
    );

    // downloadPDF(resp.data.path);

    console.log(resp.data.path);
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

function confrimPaymentInscriprion(index, id) {
  Swal.fire({
    title: "Tem certeza que deseja confirmar este pagamento?",
    text: "Não terá como reverter esta operação!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Finalizar o proceder!",
    cancelButtonText: "Cancelar!",
  }).then(async (result) => {
    try {
      loading.value = true;
      if (result.isConfirmed) {
        const resp = await PaymentStoreModule.actions.confirmPayment_(id);

        if (resp.data.status) {
          inscriptionsData.value[index].isActive = 1;
          toast.success(resp.data.message, {
            autoClose: 1000,
          });
        }
      }
    } catch (error) {
      if (error.response.data) {
        toast.error(error.response.data.message, {
          autoClose: 1000,
        });
      }
      console.log(error.response.data);
    } finally {
      loading.value = false;
    }
  });
}
function clearInputs() {
  studentForm.value.curseToUpdateOld = "";
  studentForm.value.fullName = "";
  studentForm.value.fathers_filliation = "";
  studentForm.value.mothers_filliation = "";
  studentForm.value.gender = "";
  studentForm.value.birthDate = "";
  studentForm.value.contacts.contact = "";
  studentForm.value.email = "";
  studentForm.value.is_deficient = "";
  studentForm.value.last_school_frequency = "";
  studentForm.value.last_school_frequency_year = "";
  studentForm.value.nactionality = "";
  studentForm.value.province_id = "";
  studentForm.value.district_id = "";
  studentForm.value.address_location = "";
  studentForm.value.doc_type = "";
  studentForm.value.doc_number = "";
  studentForm.value.hasCertificate = 0;
  studentForm.value.trainingArea = "";
  studentForm.value.block = "";
  studentForm.value.house_number = "";
  enableProviceAndDistrict.value = false;
}
onMounted(() => {
  getAllInscriptions();
  FilterCourse();
});

// observa filtros
watch([searchQuery, entryYear, typeFilterInscription], () => {
  getAllInscriptions();
});
</script>
 